var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    rx: 2,
    fill: "#727272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.5H17",
    stroke: "#727272",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_7022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66583 19.667V12.2203L12.9192 15.4736C13.1792 15.7336 13.6058 15.7336 13.8658 15.4736C14.1258 15.2136 14.1258 14.7936 13.8658 14.5336L9.4725 10.1403C9.2125 9.88031 8.7925 9.88031 8.5325 10.1403L4.1325 14.527C3.8725 14.787 3.8725 15.207 4.1325 15.467C4.3925 15.727 4.8125 15.727 5.0725 15.467L8.3325 12.2203V19.667C8.3325 20.0336 8.6325 20.3336 8.99917 20.3336C9.36583 20.3336 9.66583 20.0336 9.66583 19.667Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_7022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(1 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.f4b2e9f46f3b22c53174e27e170f9322.svg";
export { ForwardRef as ReactComponent };